module.exports = __webpack_public_path__ + "img/icon-payangel-rewards.cd9979f6.svg";